const forgetPassword = {
  title: "Forgot Password?",
  subtitle: "To reset your forgotten password, kindly provide your\nregistered email address.",
  labels: {
    email: "Email",
  },
  placeholders: {
    email: "Enter email",
    password: "Enter password",
  },
  previous: "Previous",
  actionBTN: "Reset password",
  enterNewPassword: "Enter a new password for ",
  resetSuccess: {
    title: "Reset Email sent!",
    description: "Please check your inbox to reset your password.",
    button: "Go to Login",
  },
};

export default forgetPassword;
